function SunIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

/**
 * Derives a short human-readable provider label from the LLM base URL.
 * Examples:
 *   https://openrouter.ai/api/v1         → "openrouter.ai"
 *   http://host.docker.internal:11434/v1  → "host.docker.internal:11434"
 */
function providerFromBaseUrl(baseUrl) {
  if (!baseUrl) return 'LLM';
  try {
    const { hostname, port } = new URL(baseUrl);
    return port ? `${hostname}:${port}` : hostname;
  } catch {
    return baseUrl;
  }
}

export default function ChatHeader({
  title,
  theme,
  onToggleTheme,
  modelName,
  llmBaseUrl,
  availableModels = [],
  onModelChange,
}) {
  const providerLabel = providerFromBaseUrl(llmBaseUrl);

  return (
    <header className="chat-header">
      <div className="header-left">
        <div className="header-status" />
        <h1 className="header-title">
          {title || <span className="header-title--placeholder">New conversation</span>}
        </h1>
      </div>
      <div className="header-right">
        {/* Provider badge — always visible */}
        <span className="header-badge">{providerLabel}</span>

        {/* Model selector — dropdown when multiple models, plain badge when only one */}
        {availableModels.length > 1 ? (
          <select
            id="header-model-select"
            className="header-model-select"
            value={modelName}
            onChange={(e) => onModelChange?.(e.target.value)}
            title="Switch active model"
          >
            {availableModels.map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        ) : (
          modelName && <span className="header-badge">{modelName}</span>
        )}

        <button
          className="theme-toggle"
          onClick={onToggleTheme}
          title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
        </button>
      </div>
    </header>
  );
}